import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';

import ro from './i18n/locales/ro.json';
import en from './i18n/locales/en.json';

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: ro },
      en: { translation: en },
    },
    // Romanian company, Romanian primary market — a brand-new visitor with
    // no stored `i18nextLng` yet (exactly the self-serve /signup scenario)
    // and a browser reporting a non-'ro' locale otherwise fell through to
    // English by default (found live 2026-08-03, Stefan hit this himself
    // going through his own signup flow).
    fallbackLng: 'ro',
    supportedLngs: ['ro', 'en'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    // 'navigator' deliberately dropped from detection order, 2026-09-07 —
    // Stefan hit the exact same "defaults to English" class of bug the
    // fallbackLng comment above already describes, this time on the public
    // pickup-remote-link page AND the global cookie banner, both in a
    // browser reporting an English OS/browser locale. Romanian company,
    // Romanian primary market — an explicit language switch (which sets
    // localStorage) always wins; absent that, 'ro' now wins over whatever
    // the visitor's browser happens to report, not the other way around.
    detection: {
      order: ['localStorage', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    returnNull: false,
  });

if (!i18next.language) {
  void i18next.changeLanguage('ro');
}

// Zod's own messages are English ("String must contain at most 128 character(s)") and reach the
// screen through <FormMessage>. Schemas with an explicit message keep it; everything else lands here.
z.setErrorMap((issue) => {
  if (issue.code === z.ZodIssueCode.invalid_type && (issue.received === 'undefined' || issue.received === 'null')) {
    return { message: i18next.t('validation.required') };
  }
  if (issue.code === z.ZodIssueCode.too_small && issue.type === 'string') {
    return {
      message:
        Number(issue.minimum) <= 1
          ? i18next.t('validation.required')
          : i18next.t('validation.tooShort', { count: Number(issue.minimum) }),
    };
  }
  if (issue.code === z.ZodIssueCode.too_big && issue.type === 'string') {
    return { message: i18next.t('validation.tooLong', { count: Number(issue.maximum) }) };
  }
  return { message: i18next.t('validation.invalid') };
});

export const i18n = i18next;
